import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PERMISSION_SUB_MODULES } from '@/shared/const'
import { PageWrapper } from '@/shared/ui/page-wrapper'
import { PermissionGuard } from '@/shared/ui/permission-guard'
import { DashboardWidget } from '@/widgets/dashboard-widget'

export const Route = createFileRoute('/_auth/reports/dashboards')({
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()

  return (
    <PermissionGuard permission={PERMISSION_SUB_MODULES.SCHOOL_DASHBOARD}>
      <PageWrapper title={t('Дашборды')}>
        <DashboardWidget cardLayout="reports" />
      </PageWrapper>
    </PermissionGuard>
  )
}
